import axios, { AxiosResponse } from 'axios';
import { Action, ActionCreator, Dispatch } from 'redux';
import { setFieldErrors } from '../redux/actions/fieldErrors';
import { addFormError } from '../redux/actions/fieldErrors';
import { setRedirectUrl } from '../redux/actions/redirects';
import { APIError } from '../types/APIError';
import { clearJwtToken, clearMfaToken, getJwtToken, getMfaToken, validateJWT } from './jwt';

interface ApiRequestOptions {
    auth?: 'user' | 'mfa';
}

const getConfig = (params = {}, options: ApiRequestOptions = {}) => {
    const token = options.auth === 'mfa' ? getMfaToken() : getJwtToken();
    return {
        headers: token && validateJWT(token) ? { Authorization: `Bearer ${token}` } : {},
        params,
    };
};

let API_URL = '';
export const initApi = (apiUrl: string) => {
    API_URL = apiUrl;
};
const get = <TResponseBody>(
    url: string,
    params?: Record<string, any>,
    options?: ApiRequestOptions,
): Promise<AxiosResponse<TResponseBody>> => {
    return axios.get<TResponseBody>(`${API_URL}/${url}`, getConfig(params, options));
};
const post = <TRequestBody, TResponseBody>(
    url: string,
    data: TRequestBody,
    params?: Record<string, any>,
    options?: ApiRequestOptions,
) => {
    return axios.post<TResponseBody>(`${API_URL}/${url}`, data, getConfig(params, options));
};
const put = <TRequestBody, TResponseBody>(url: string, data: TRequestBody) => {
    return axios.put<TResponseBody>(`${API_URL}/${url}`, data, getConfig());
};
const patch = <TRequestBody, TResponseBody>(url: string, data: TRequestBody) => {
    return axios.patch<TResponseBody>(`${API_URL}/${url}`, data, getConfig());
};
const del = <TResponseBody>(url: string) => {
    return axios.delete<TResponseBody>(`${API_URL}/${url}`, getConfig());
};
export const api = {
    get,
    post,
    put,
    patch,
    delete: del,
};

export const handleApiErrors = <A extends Action>(
    dispatch: Dispatch,
    failureAction: ActionCreator<A>,
    err: APIError | any,
) => {
    const { response, message } = err;
    if (response && response.status === 400) {
        if (typeof response.data === 'string') dispatch(addFormError(response.data));
        else {
            dispatch(setFieldErrors(response.data.errors));
            dispatch(addFormError(response.data.title));
        }

        return dispatch(failureAction(null));
    }
    if (response && response.status === 401) {
        clearJwtToken();
        clearMfaToken();
        dispatch(failureAction('Unauthorized'));
        return dispatch(setRedirectUrl('/auth/login'));
    }

    return dispatch(failureAction(message));
};
